import { connect } from 'react-redux'
import { getTimelines } from '@selectors/data/timeline_selectors.js'
import { getPhotos } from '@selectors/data/photo_selectors.js'
import { gridItemsSubsetListSelector } from '@selectors/data/timeline_grid_selectors.js'
import { getCurrentUser } from '@selectors/data/user_selectors.js'
import TimelineGrid from '../components/timeline_grid.jsx'

const mapStateToProps = (state, props) => {
  const currentUser = getCurrentUser(state)
  const timelines = getTimelines(state, props)
  const gridItems = gridItemsSubsetListSelector(state, props)
  const photos = getPhotos(state, props)
  return {
    currentUser,
    gridItems,
    timelines,
    photos,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TimelineGrid)
